// extracted by mini-css-extract-plugin
module.exports = {"ratio_preview_box":"FJBorder_ratio_preview_box__2l2C_"};